export const download = (blobObject, fileName) => {
  const url = window.URL.createObjectURL(blobObject);
  const link = document.createElement('a');
  link.href = url;

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadFromUrl = (fileUrl, fileName) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  link.target = '_blank';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
};
